//Jds

import { ActionButton, Button, Container, Icon, Text } from "@jds/core";
import {
  setActiveModalClose,
  setPlanModalClose,
  setSubscriptionPlan,
} from "../../../store/state-slices/plans";
import { useDispatch, useSelector } from "react-redux";
import IconRocket from "../../../assets/svg/ic_enterpreneurial.svg";
import useApiHttp from "../../../hooks/use-http";
import { useEffect, useState } from "react";
import Loader from "../Loader/Loader";

const ActiveAlert = (props) => {
  const dispatch = useDispatch();
  const { activeMsg } = useSelector((state) => state.plans);
  const [storageDetails, setStorageDetails] = useState({});
  const { sendRequest: getStorage, isLoading: isStorageGetting } = useApiHttp();
  useEffect(() => {
    getStorage(
      {
        // url: `get-storage-details`,
        url: `storage/user`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        setStorageDetails(data?.data);
      },
      (err, data) => {
        console.log("err==>" + data);
      }
    );
  }, []);
  if (isStorageGetting) {
    return (
      <Loader size="small" containerProps={{ style: { marginTop: "16px" } }} />
    );
  }
  return (
    <Container
      style={{ alignItems: "center", width: "100%" }}
      fullWidth
      gap={16}
      direction="column"
    >
      <Icon ic={"IcAlert"} kind="background" size="xxl" />
      <Text
        color="primary_grey_100"
        appearance="heading-xs"
        text="Subscription Expired"
      />
      <p
        style={{
          color: "var(--color-primary-grey-80)",
          fontSize: "18px",
          fontWeight: "700",
          textAlign: "center",
        }}
      >
        {activeMsg
          ? activeMsg
          : "Please update your plan to continue accessing our services."}
      </p>
      <ActionButton
        size="medium"
        kind="primary"
        iconPosition="right"
        icon={<img src={IconRocket} alt="" />}
        appearance="positive"
        onClick={() => {
          dispatch(setPlanModalClose(false));
          dispatch(setActiveModalClose(true));
          if (
            !storageDetails?.planActive ||
            storageDetails?.freeTrialPlanActive
          ) {
            dispatch(setSubscriptionPlan(true));
          } else {
            dispatch(setSubscriptionPlan(false));
          }
        }}
        label={
          !storageDetails?.planActive || storageDetails?.freeTrialPlanActive
            ? "Subscribe"
            : "Upgrade"
        }
      ></ActionButton>
    </Container>
  );
};

export default ActiveAlert;
